import Arrow from './Arrow'
import styles from './Pagination.module.scss'

export default function Pagination({ pages, active, changePage }) {
  /**
   * Format array of page numbers.
   */
  const getPageNumbers = () => {
    const pageNumbers = []

    // If a small number of pages, output normally.
    if (pages < 6) {
      for (let i = 1; i <= pages; i += 1) {
        pageNumbers.push(i)
      }
      // If a larger number, output a spacer.
    } else {
      // Always show the first number.
      pageNumbers.push(1)

      // To be translated to an elipsis.
      if (active > 2) {
        pageNumbers.push(null)
      }

      for (let i = active - 2; i <= active + 2; i += 1) {
        if (i > 1 && i < pages) {
          pageNumbers.push(i)
        }
      }

      // To be translated to an elipsis.
      if (active < pages - 2) {
        pageNumbers.push(null)
      }

      // Always show the last number.
      pageNumbers.push(pages)
    }

    return pageNumbers
  }

  /**
   * Get active / non-active classes for numbers.
   */
  const getPageNumberClass = (pageNumber) => {
    if (pageNumber === active) {
      return `${styles.pageNumber} ${styles.activePageNumber}`
    }

    return styles.pageNumber
  }

  /**
   * Change page.
   * Guard against changing to identical value
   */
  const handlePageChange = (newPage) => {
    if (newPage !== active) {
      changePage(newPage)
    }
  }

  /**
   * Get page link or spacer.
   */
  const getPaginationItemType = (pageNumber) => {
    if (pageNumber === null) {
      return (
        <span className={styles.spacer} key={pageNumber}>
          &hellip;
        </span>
      )
    }
    return (
      <span
        className={getPageNumberClass(pageNumber)}
        role="button"
        onClick={() => handlePageChange(pageNumber)}
        key={pageNumber}
      >
        {pageNumber}
      </span>
    )
  }

  return (
    <section className={styles.section}>
      <div className="container">
        <div className={styles.wrap}>
          <Arrow
            direction="previous"
            current={active}
            max={pages}
            changePage={changePage}
          />

          {getPageNumbers().map((pageNumber) =>
            getPaginationItemType(pageNumber),
          )}

          <Arrow
            direction="next"
            current={active}
            max={pages}
            changePage={changePage}
          />
        </div>
      </div>
    </section>
  )
}
